// React component for displaying responsive series header.

import GrComponentFactory from "../gr_component_factory";
import ExpandableHtml from "../user_content/expandable_html";
// import ShareDialog from "../share_dialog";
import GrPropTypes from "../shared/gr_prop_types";

import { PropTypes } from "react";

export default GrComponentFactory.createClass({
  displayName: "SeriesHeader",

  propTypes: {
    description: PropTypes.shape(GrPropTypes.expandableHtml()).isRequired,
    editPath: PropTypes.string,
    // shareDialog: PropTypes.shape(GrPropTypes.shareDialog()),
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  },

  renderToggleSecondaryWorks() {
    // soon™
  },

  renderWTRSeriesButton() {
    // probably not soon™
  },

  render() {
    return (
      <div className="responsiveSeriesHeader">
        <div className="responsiveSeriesHeader__title">
          <h1 className="gr-h1 gr-h1--serif gr-h1--noMargin u-paddingBottomTiny">
            {this.props.title}
          </h1>

          {this.props.editPath &&
            <a className="responsiveSeriesHeader__editLink gr-hyperlink gr-hyperlink--quiet"
               href={this.props.editPath}>
              Edit
            </a>
          }
        </div>

        <div className="responsiveSeriesHeader__subtitle u-paddingBottomSmall">
          {this.props.subtitle}
        </div>

        <div className="u-paddingBottomSmall">
          <ExpandableHtml {...this.props.description} />
        </div>

        {/*
          <div className="responsiveSeriesHeader__buttonContainer u-paddingBottomSmall">
            {this.renderWTRSeriesButton()}
            {this.renderToggleSecondaryWorks()}
            {<ShareDialog {...this.props.shareDialog} />}
          </div>
        */}
      </div>
    );
  },
});
